/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */

'use client'

import { pageEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import React, { useEffect, useState } from 'react'
import { careersSegmentEventCommonPropFunc } from '@utils/carrersSegmentProperties'
import parse from 'html-react-parser'
import useIdentifyEvent from '@hooks/useIdentityEvent'
import LinkButton from '../link-button/link-button'
import styles from './styles/footer-section.module.css'

const FooterSection = ({ CMSData }) => {
  const { footerButtonJson, footerHeading } = CMSData
  const [triggeredScrollPositions, setTriggeredScrollPositions] = useState({})
  useIdentifyEvent()

  useEffect(() => {
  (async () => {
    const properties = await careersSegmentEventCommonPropFunc()
    pageEvent('careers', {
      ...properties,
      on_page_load: true
    })
  })()
}, [])

  useEffect(() => {
    const handleScroll = async () => {
      const windowHeight = window?.innerHeight
      const documentHeight = document?.documentElement?.scrollHeight
      const scrollTop = window?.pageYOffset || document?.documentElement?.scrollTop

      const scrolledPercentage = Math.floor((scrollTop / (documentHeight - windowHeight)) * 100)

      let scrollPosition = ''

      if (scrolledPercentage === 25 && !triggeredScrollPositions['25']) {
        scrollPosition = '25%'
        setTriggeredScrollPositions({ ...triggeredScrollPositions, 25: true })
      } else if (scrolledPercentage === 50 && !triggeredScrollPositions['50']) {
        scrollPosition = '50%'
        setTriggeredScrollPositions({ ...triggeredScrollPositions, 50: true })
      } else if (scrolledPercentage === 75 && !triggeredScrollPositions['75']) {
        scrollPosition = '75%'
        setTriggeredScrollPositions({ ...triggeredScrollPositions, 75: true })
      } else if (scrolledPercentage === 95 && !triggeredScrollPositions['95']) {
        scrollPosition = '100%'
        setTriggeredScrollPositions({ ...triggeredScrollPositions, 95: true })
      }

      if (scrollPosition) {
        const properties = await careersSegmentEventCommonPropFunc()
        pageEvent('view_user_scroll', {
          ...properties,
          vertical_scroll: scrollPosition,
        })
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [careersSegmentEventCommonPropFunc, pageEvent, triggeredScrollPositions])

  return (
    <footer className={styles.footerSection}>
      {parse(footerHeading)}
      <LinkButton
        eventName="last btn clicked see open positions"
        btnText={footerButtonJson?.buttonText}
        btnStyle={footerButtonJson?.buttonStyle}
        btnLink={`/careers/${footerButtonJson?.buttonLink}`}
      />
    </footer>
  )
}

export default FooterSection
